import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "journal smart-journal text-big",
  style: {}
}
const _hoisted_2 = { class: "container maxWidth-md" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-6 text-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_6 = {
  class: "journal-page",
  style: {"position":"relative"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","top":"5px","right":"8px","color":"#999"} }, "1", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"2px","background-color":"blue","margin-top":"-5px","margin-bottom":"20px"} }, null, -1)
const _hoisted_9 = {
  class: "journal-paper",
  style: {"position":"relative"}
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "journal-suggestion-box visible-xs" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-refresh" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "journal-body-hash" }, "#", -1)
const _hoisted_18 = { class: "journal-body-heading" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { style: {"display":"none"} }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "journal-instructions" }, null, -1)
const _hoisted_22 = { class: "col-sm-6" }
const _hoisted_23 = {
  class: "journal-suggestion-box hidden-xs",
  style: {"margin-left":"15px"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-refresh" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "journal-body-hash" }, "#", -1)
const _hoisted_32 = { class: "journal-body-heading" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { Tooltip } from "uiv";
import { ref, computed, watch, onMounted, onBeforeUnmount } from "vue";
import { csContext } from "../../services/cs-context";
import processPromptVars, {
  applyVars,
  getDataContext,
  syntaxToApiCall,
} from "../smart-scratchpad/process-prompt-vars";
import chat, { multiChat } from "../smart-scratchpad/chat";
import { splitRegex } from "../smart-search/complete";
import shuffled from "../smart-search/shuffled";
import { CmsSmartJournalPage } from "../../services/cms/cms-type-definitions";
import hotReloadPreserve from "./hot-reload-preserve";
import {
  codes,
  getContinuations,
  getReasoning,
  getReasoning2,
  getWatermark,
  headingsFromSubtitle,
  headingsFromTitle,
  letterToNumber,
  mergeTopic,
  startersFromSubtitle,
  startersFromSubtitleWithAttitude,
} from "./prompts";
import { jyranians } from "./jyranians";

interface IdeaItem {
  text: string;
  recommended: boolean;
  recommendationReason: string;
  strengthIndexes: number[];
  inserted: boolean;
  hides: IdeaItem | null;
  replacedBy: IdeaItem | null;
  replaces: IdeaItem | null;
}

interface IdeaGroup {
  heading: string;
  choice: string | null;
  mergedTopic: string;
  allItems: IdeaItem[];
  curatedItems: IdeaItem[];
  version: number;
  parent: IdeaGroup | null;
  type: "heading" | "starter" | "continuation";
  phrase: string;
}

interface EditContext {
  heading: any;
  mode: string;
  title: string;
  body: string;
  phrase: string;
}

const dynamicWatermark = "Write more...";


export default /*#__PURE__*/_defineComponent({
  __name: 'smart-journal',
  props: {
    doc: {}
  },
  setup(__props: any) {

/* eslint-disable no-restricted-syntax */
const props = __props;

// template refs
const textareaRef = ref<HTMLTextAreaElement | null>(null);

const dataContext = ref(getDataContext());

const initialTitle = computed(() => {
  return props.doc?.data.page_title.trim() || "What has gone well for me in the past year?";
});

const title = ref(initialTitle);

const editContext = ref<EditContext>({
  mode: "headings",
  title: "",
  body: "",
  phrase: "",
  heading: "",
});

const initialIdeaGroup = computed<IdeaGroup>(() => {
  const arr = [];
  return {
    parent: null,
    choice: null,
    mergedTopic: title.value,
    phrase: "",
    heading: title.value,
    allItems: [],
    curatedItems: arr,
    version: 0,
    type: "heading",
  };
});

const bio = ref("bio");

const body = ref("\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n");
const group = ref<IdeaGroup>(initialIdeaGroup.value);

const bodyFragments = computed(() => {
  const fragments = body.value.split(/(^#)|(\n#)|(\n)/g).filter((x) => x);
  return fragments.map((f, i) => {
    // Html escape f
    const f2 = f.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    if (f2 === "#" || f2 === "\n#") {
      return { className: "journal-body-hash", text: f2 };
    }
    if ((fragments[i - 1] === "#" || fragments[i - 1] === "\n#") && f2 !== "\n") {
      return { className: "journal-body-heading", text: f2 };
    }
    return { className: "journal-body-span", text: f2 };
  });
});

const bodyHtml = computed(() => {
  return bodyFragments.value.map((f) => `<span class="${f.className}">${f.text}</span>`).join("");
});

function refresh(removedItem: IdeaItem, replacingItem: IdeaItem) {
  if (replacingItem) {
    removedItem.replacedBy = replacingItem;
    replacingItem.replaces = removedItem;
  }
}

function ultimateItem(item: IdeaItem) {
  if (item.replacedBy) {
    return ultimateItem(item.replacedBy);
  }
  return item;
}

const itemsInDisplayOrder = computed(() => {
  const pass0 = group.value.curatedItems;
  const pass1 = [] as IdeaItem[];
  // eslint-disable-next-line no-restricted-syntax
  for (const item of group.value.curatedItems) {
    const replacingItem = ultimateItem(item);
    if (!pass1.includes(replacingItem)) {
      pass1.push(replacingItem);
    }
  }
  return pass1;
});

async function setStatements(
  prompt: string,
  ideaGroup: IdeaGroup,
  type: "heading" | "starter" | "continuation",
) {
  const headingsPrompt = await processPromptVars(prompt, dataContext.value);
  ideaGroup.version += 1;
  const { version } = ideaGroup;
  // TODO: when refactoring this to the composition API I realised this is buggy on live site - throwing errors due to the token_bias keys
  await chat(
    {
      ...headingsPrompt.processed,
      token_bias: {
        "1": -100,
        "01": -100,
        "-": -100,
        "\\": -100,
        "Sure": -100,
        "\n": 5,
        "My": 4,
        " my": 5,
      },
    },
    (headingsResponse) => {
      if (version !== ideaGroup.version) {
        return;
      }

      const split = headingsResponse.split(/\n+/g).filter((s) => s.trim());
      let allItems = split.map((s) =>
        s
          .replace(/\\$/g, "")
          .replace(/^\d+\)?(\.\.\.)?|/g, "")
          .trim(),
      );

      if (false && type === "starter") {
        allItems = allItems.map((l) => l.split(":").slice(1).join(":").trim());
      }

      group.value.allItems = allItems.map((text) => ({
        text,
        recommendationReason: "",
        recommended: false,
        inserted: false,
        strengthIndexes: [],
        hides: null,
        hidden: false,
        replacedBy: null,
        replaces: null,
      }));
    },
  );

  const r = getReasoning(group.value.allItems, title.value, 0);
  const p = await processPromptVars(r, dataContext.value);
  const matchedItems = [] as { strengths: string[]; text: string }[];
  const cb = (text: string) => {
    const split = text.split(/- Strengths:+/g).filter((s) => s.trim());

    // eslint-disable-next-line no-restricted-syntax
    for (const sp of split) {
      const matchingLetters = sp.match(/[^A-Za-z]([A-Z])[^A-Za-z]/g) || [];
      const matchingCodes = sp.match(/([0-9][0-9][0-9])/g) || [];

      // eslint-disable-next-line no-restricted-syntax
      for (const code of matchingCodes) {
        const index = codes.indexOf(code);
        if (index >= 0 && index < group.value.allItems.length) {
          if (!group.value.curatedItems.includes(group.value.allItems[index])) {
            group.value.curatedItems.push(group.value.allItems[index]);
          }

          group.value.allItems[index].recommended = true;
          group.value.allItems[index].strengthIndexes = matchingLetters.map((l) =>
            letterToNumber(l.trim()),
          );
        }
      }
    }
  };

  const text = await chat(
    {
      ...p.processed,
      token_bias: {},
    },
    cb,
  );

  // eslint-disable-next-line no-restricted-syntax
  for (const item of group.value.allItems) {
    if (item.strengthIndexes) {
      // eslint-disable-next-line no-await-in-loop
      const awaited = await processPromptVars(
        getReasoning2(item.strengthIndexes, item.text),
        dataContext.value,
      );
      // eslint-disable-next-line no-await-in-loop
      item.recommendationReason = await chat(awaited.processed);
    }
  }
}

const mode = computed(() => {
  return "headings";
});

function getEditContext() {
  const currentTitle = title.value.trim() || "(no title)";
  // Get each of the paragraphs in the doc as an array.
  const lines = [] as string[];

  const currentBody = lines.join("\n");

  // let head = this.editor.state.selection.$head;

  // let depth = head.depth;
  // let node = this.editor.state.selection.$head.parent;

  const heading = "";
  const phrase = "";
  const started = false;
  const finished = false;

  const currentEditContext = {
    mode: mode.value,
    title: currentTitle,
    body: currentBody,
    phrase,
    heading,
  } as EditContext;
  editContext.value = currentEditContext;
  return currentEditContext;
}

const lastGoEditContext = ref(editContext.value);

async function go(): Promise<void> {
  const ec = getEditContext();

  if (
    lastGoEditContext.value.title === ec.title &&
    lastGoEditContext.value.body === ec.body &&
    lastGoEditContext.value.phrase === ec.phrase &&
    lastGoEditContext.value.heading === ec.heading
  ) {
    return;
  }

  lastGoEditContext.value = ec;
  let type: "heading" | "starter" | "continuation" = "heading";

  if (ec.heading.trim()) {
    type = "starter";
  }

  if (ec.phrase.trim() && ec.heading.trim()) {
    type = "continuation";
  }

  // if (ec.title.trim() === this.initialTitle.trim() && !ec.heading.trim()) {
  //   this.group = this.initialIdeaGroup;
  // } else {
  const arr = [];
  const ideaGroup: IdeaGroup = {
    parent: null,
    choice: null,
    mergedTopic: "",
    heading: ec.heading,
    phrase: ec.phrase,
    allItems: [],
    curatedItems: arr,
    version: 0,
    type,
  };

  group.value = ideaGroup;
  let mergedTopic: string;
  setStatements(headingsFromTitle(ec.title), group.value, type);

  // if (type === "starter") {
  //   setStatements(startersFromSubtitle(ec.heading, ec.title), group.value, type);
  // } else if (type === "heading") {
  //   setStatements(headingsFromTitle(ec.title), group.value, type);
  // } else if (type === "continuation") {
  //   setStatements(getContinuations(ec.phrase, ec.heading, ec.title), group.value, type);
  // }
}

function setAttitude(jyranian: string) {
  go();
}

function editCurrentNode(text: string) {
  let from: number;
  let to: number;

  // Get the editor's current node.
}

function deepen(subtopic: string) {
  const parent = group.value;
  const ideaGroup: IdeaGroup = {
    parent,
    heading: subtopic,
    mergedTopic: "",
    choice: subtopic,
    allItems: [],
    curatedItems: [],
    version: 0,
    type: "heading",
    phrase: "",
  };
  group.value = ideaGroup;

  editCurrentNode(subtopic);
  // insertAfterCurrentParagraph(choice, "heading");
  setStatements(headingsFromSubtitle(subtopic, title.value), group.value, "heading");
}

async function getMergedTopic(pageTitle: string, rootTopic: string, subtopic: string) {
  return (await chat(mergeTopic(pageTitle, rootTopic, subtopic))).replace(/"$/g, "");
}

function resize() {
  const textarea = textareaRef.value as HTMLTextAreaElement;
  setTimeout(() => {
    textarea.scroll(0, 0);
    const heightBefore = textarea.scrollHeight;
    textarea.style.height = `${Math.max(heightBefore - 27, 0)}px`;
    textarea.style.height = `${textarea.scrollHeight}px`;
    const heightAfter = textarea.scrollHeight;
    if (heightBefore !== heightAfter) {
      setTimeout(() => resize(), 5);
    }
  }, 0);
}

watch(body, () => {
  resize();
});

function insert(item: IdeaItem, replacingItem: IdeaItem) {
  let insertion = `#${item.text}\n${item.recommendationReason}`;
  if (body.value.trim()) {
    insertion = `\n\n${insertion}`;
  }
  body.value = body.value.trimEnd() + insertion;
  item.inserted = true;
  refresh(item, replacingItem);
}

onMounted(() => {
  hotReloadPreserve({ title: title.value, group: group.value, body: body.value }, "smart-journal", [
    "title",
    "group",
    "body",
  ]);

  // When the selection changes, run a method.
  // this.editor.on("selectionUpdate", () => {
  //   this.go();
  // });

  go();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("textarea", {
              class: "journal-textarea journal-textarea-x",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
              "aria-label": "title"
            }, null, 512), [
              [_vModelText, title.value]
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((body).value = $event)),
                ref_key: "textareaRef",
                ref: textareaRef,
                class: "journal-textarea journal-main-textarea",
                style: {"width":"100%"},
                "aria-label": "journal-entry"
              }, null, 512), [
                [_vModelText, body.value]
              ]),
              _createElementVNode("div", {
                class: "journal-textarea-backing",
                innerHTML: bodyHtml.value
              }, null, 8, _hoisted_10),
              _createElementVNode("div", { class: "journal-watermark" }, _toDisplayString(dynamicWatermark)),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(" Suggestions: "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsInDisplayOrder.value.slice(0, 1), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i.toString() + 'a',
                    class: "journal-suggestion"
                  }, [
                    (itemsInDisplayOrder.value[2])
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (refresh(item, itemsInDisplayOrder.value[1])),
                          style: {"float":"right"},
                          class: "btn btn-default",
                          type: "button"
                        }, _hoisted_15, 8, _hoisted_13))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (insert(item, itemsInDisplayOrder.value[1]))
                    }, [
                      _hoisted_17,
                      _createElementVNode("span", _hoisted_18, _toDisplayString(item.text), 1),
                      _createTextVNode(),
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(item.recommendationReason), 1)
                    ], 8, _hoisted_16)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, _toDisplayString(editContext.value), 1),
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createTextVNode(" Suggestions: "),
            _hoisted_25,
            _hoisted_26,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsInDisplayOrder.value.slice(0, 2), (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i.toString() + 'a',
                class: "journal-suggestion"
              }, [
                (itemsInDisplayOrder.value[2])
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (refresh(item, itemsInDisplayOrder.value[2])),
                      style: {"float":"right"},
                      class: "btn btn-default",
                      type: "button"
                    }, _hoisted_29, 8, _hoisted_27))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  onClick: ($event: any) => (insert(item, itemsInDisplayOrder.value[2]))
                }, [
                  _hoisted_31,
                  _createElementVNode("span", _hoisted_32, _toDisplayString(item.text), 1),
                  _createTextVNode(),
                  _hoisted_33,
                  _createTextVNode(" " + _toDisplayString(item.recommendationReason), 1)
                ], 8, _hoisted_30),
                _hoisted_34,
                _hoisted_35
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})